export default {
  header: 'We couldn’t load your order',
  text: 'Something went wrong while preparing your order. Your basket is safe — please try again.',
  retry: 'Try again',
  address_header: 'We need your delivery address',
  address_text: 'We can’t work out your total until we know where to deliver. Your basket is safe.',
  address_action: 'Add delivery address',
  back_checkout: 'Back to your order',
  back_basket: 'Back to your basket',
};
